import type React from 'react';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { Drawer } from 'ui-components/components/drawer/drawer';
import { DrawerHeader } from 'ui-components/components/drawer/drawer-header';
import { FlexRow } from 'ui-components/components/flex/row';
import { Gap } from 'ui-components/components/flex/gap';
import { Text } from 'ui-components/components/text';
import { TextType } from 'ui-components/components/text/text-type';
import { THEME_CONSTANTS } from 'ui-components/services/button-theme-service';

import type { Workflow } from '../../types.d';
import { WorkflowCanvasZoomable } from '../workflow-canvas-zoomable';
import { messages } from './messages';
import styles from './styles.module.less';

type WorkflowDrawerZoomableProps = {
  workflow: Workflow | null;
  onClose: () => void;
};

export const WorkflowDrawerZoomable: React.FC<WorkflowDrawerZoomableProps> = ({ workflow, onClose }) => {
  const intl = useIntl();
  const isEditMode = workflow !== null;

  const heading = isEditMode ? workflow.name : intl.formatMessage(messages.newWorkflowTitle);

  const handleCancel = useCallback(() => {
    onClose();
  }, [onClose]);

  return (
    <Drawer onCancel={handleCancel} onClose={handleCancel}>
      <DrawerHeader
        className={styles['drawer-header']}
        closeButtonAriaLabel={messages.closeDrawer}
        title={
          <FlexRow gap={Gap.Space12}>
            <Text textType={TextType.H3} value={heading} />

            <FlexRow gap={Gap.Space12}>
              <Button disabled theme={THEME_CONSTANTS.primary}>
                <Text textType={TextType.Caption} value={messages.saveButton} />
              </Button>
            </FlexRow>
          </FlexRow>
        }
      />
      <WorkflowCanvasZoomable />
    </Drawer>
  );
};
